import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import { Layout, PostCard } from "../components/common";
import { MetaData } from "../components/common/meta";

/**
 * Tag page (/tag/:slug)
 *
 * Loads all posts for the requested tag incl. pagination.
 *
 */
const Tag = ({ data, location }) => {
    console.log({ data });
    const tag = data.ghostTag;
    const posts = data.allGhostPost.edges;

    return (
        <>
            <MetaData data={data} location={location} type="series" />
            <Layout>
                <div className="container">
                    <div className="archive-section">
                        <h1 className="archive-title is-tag global-tags-hash-sign">
                            {tag.name}
                        </h1>
                        <span className="archive-details">
                            {posts.length} posts
                        </span>
                        {tag.description && (
                            <p className="archive-description">
                                {tag.description}
                            </p>
                        )}
                    </div>
                    <div className="loop-section">
                        <section className="loop-wrap">
                            {posts.map(({ node }, index) => (
                                // The tag below includes the markup for each post - components/common/PostCard.js
                                <PostCard
                                    index={index}
                                    key={node.id}
                                    post={node}
                                />
                            ))}
                        </section>
                    </div>
                </div>
            </Layout>
        </>
    );
};

Tag.propTypes = {
    data: PropTypes.shape({
        ghostTag: PropTypes.shape({
            name: PropTypes.string.isRequired,
            description: PropTypes.string,
        }),
        allGhostPost: PropTypes.object.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    pageContext: PropTypes.object,
};

export default Tag;

export const pageQuery = graphql`
    query GhostTagQuery($slug: String!, $limit: Int!, $skip: Int!) {
        ghostTag(slug: { eq: $slug }) {
            ...GhostTagFields
        }
        allGhostPost(
            sort: { order: DESC, fields: [published_at] }
            filter: { tags: { elemMatch: { slug: { eq: $slug } } } }
            limit: $limit
            skip: $skip
        ) {
            edges {
                node {
                    ...GhostPostFields
                }
            }
        }
    }
`;
